module.exports = __webpack_public_path__ + "clickup-2-8ecba96a500c97fade58d3a6b9d9c4a2.webp";